"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarDialog = _react2.default.createClass({
    displayName: "CalendarDialog",
    executeAction: function executeAction() {
        var result = this.props.action(this.props.actionArgs);
        if (result !== false) {
            this.props.cancel();
        }
        return result;
    },
    resetAction: function cancel() {
        this.props.reset();
        this.props.cancel();
    },
    render: function render() {
        return _react2.default.createElement(
            "div",
            { className: "react-calendar-dialog-bg" },
            _react2.default.createElement(
                "div",
                { className: "react-calendar-dialog-content" },
                _react2.default.createElement(
                    "div",
                    null,
                    this.props.confirmMessage(this.props.assignment)
                ),
                _react2.default.createElement(
                    "button",
                    { className: "react-confirm-dialog-button confirm", onClick: this.executeAction },
                    this.props.confirmText
                ),
                _react2.default.createElement(
                    "button",
                    { className: "react-confirm-dialog-button cancel", onClick: this.resetAction },
                    this.props.cancelText
                )
            )
        );
    }
});

exports.default = CalendarDialog;


/** WEBPACK FOOTER **
 ** ./src/dialogs/CalendarDialog.js
 **/